module.exports = __webpack_public_path__ + "static/media/logo_wbs_training.4dc82d6f.svg";